import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VueTableOrdering',
  props: ['controller', 'field'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props
const ICONS = {
  null: 'i-unfold-more',
  asc: 'i-arrow-down',
  desc: 'i-arrow-up',
}

const value = computed(() => {
  return (
    props.controller.valueMap.get(props.field.key)
     || {
      key: props.field.key,
      value: null,
    }
  )
})
const direction = computed(() => {
  return props.controller.directionGetter(value.value)
})
const index = computed(() => {
  return value.value.value === null
    ? -1
    : props.controller.value.findIndex((x) => x.key === props.field.key)
})
function change() {
  props.controller.change(props.field.key)
}

const __returned__ = { props, ICONS, value, direction, index, change, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})